import React from 'react';
import { Card, CardContent } from '../ui/card';

const STAT_ITEMS = [
  { key: 'total', label: 'Total Inquiries', color: 'text-cyan-600' },
  { key: 'new', label: 'New', color: 'text-blue-600' },
  { key: 'contacted', label: 'Contacted', color: 'text-yellow-600' },
  { key: 'closed', label: 'Closed', color: 'text-green-600' },
];

export const AdminStats = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-testid="admin-stats-grid">
      {STAT_ITEMS.map(({ key, label, color }) => (
        <Card key={key}>
          <CardContent className="pt-6">
            <div className="text-center">
              <div className={`text-3xl font-bold ${color}`} data-testid={`admin-stat-${key}`}>{stats[key]}</div>
              <div className="text-sm text-gray-600">{label}</div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
